import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import { EMAIL_PATTERN, IP_PATTERN, NOT_INVALID_DATE_STRING_PATTERN, PHONE_NUMBER_PATTERN} from '../consts';
import { IpGatewayValidatorService } from '../../order/services/ip-validator-gateway.service';
import { ipGatewayValidator } from '../directives/ip-validator.directive';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { DuplicateService } from './duplicate.service';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class GetFormsService {
  constructor(
    private fb: FormBuilder,
    private duplicate: DuplicateService,
    private ipGatewayValidatorService: IpGatewayValidatorService
  ) {}

  // promise
  isUniquePromise2(myduplicate: DuplicateService): AsyncValidatorFn {
    return (
      control: AbstractControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {
      if (control.disabled) {
        return of(null);
      }

      const q = new Promise((resolve) => {
        myduplicate
          .duplicate(['siteName'], control.value)
          .pipe(
            debounceTime(600),
            distinctUntilChanged((x, y) => _.isEqual(x, y))
          )
          .subscribe(
            (res: boolean) => {
              if (res === true) {
                control.setErrors({ duplicate: res });
                resolve({ duplicate: res });
              } else {
                resolve(null);
              }
            },
            () => {
              resolve(null);
            }
          );
      });
      return q;
    };
  }
  // promise
  isUniquePromiseContract(myduplicate: DuplicateService): AsyncValidatorFn {
    return (
      control: AbstractControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {
      if (control.disabled) {
        return of(null);
      }

      const q = new Promise((resolve) => {
        myduplicate
          .duplicate(['contractName'], control.value)
          .pipe(distinctUntilChanged((x, y) => _.isEqual(x, y)))
          .subscribe(
            (res: boolean) => {
              if (res === true) {
                control.setErrors({ duplicate: res });
                resolve({ duplicate: res });
              } else {
                resolve(null);
              }
            },
            () => {
              resolve(null);
            }
          );
      });
      return q;
    };
  }
  getOrderWithSite(): FormGroup {
    return this.fb.group({
      addresses: this.fb.array([this.getAddress(), this.getAddress()]),
      client: this.getClientItem(),
      misc: this.fb.group({
        commentsForm: this.fb.group({
          commentsBlog: [null],
          comments: [null],
        }),
        expeditionForm: this.fb.group({
          expeditionDate: [null, Validators.required],
          hasMaterial: [null],
          hasSetup: [null],
          orderCountThisDay: [null],
        }),
        shipmentForm: this.fb.group({
          shipment: [2],
        }),
        byForm: this.fb.group({
          updatedBy: [null],
          createdBy: [null],
        }),
        playerInfo: this.fb.group({
          displayName: [null],
          deviceMacAddress: [null],
          deviceID: [null],
        }),
      }),
      contact: this.getContact(),
      site: this.fb.group({
        id: [null],
        uuid: [null],
        externalID: [null],
        name: [
          null,
          [Validators.required, Validators.minLength(3)]
        ],
        timeZone: this.fb.group({
          id: [null],
          ianaCode: [null, Validators.required],
          name: [null],
        }),
      }),
      productionLine: this.fb.group({
        productionLine: this.fb.group({
          code: [null, Validators.required],
          name: [null],
        }),
      }),
      subscription: this.fb.group({
        cultures: this.fb.group({
          code: [null, Validators.required],
          name: [null],
          common: [null],
          rtl: [null],
        }),
        name: [null, Validators.required],
        base: this.fb.group({
          name: [null],
          prefix: [null],
          productForm: this.fb.group({
            product: this.fb.group({
              id: [null, Validators.required],
              name: [null],
              audio: [null],
              video: [null],
            }),
            status: this.fb.group({
              id: [null, Validators.required],
              name: [null],
              audio: [null],
              video: [null],
            }),
            screenRotation: this.fb.group({
              id: [{ value: null, disabled: true }, Validators.required],
              name: [{ value: null, disabled: true }],
            }),
          }),
          serverForm: this.fb.group({
            server: this.fb.group({
              id: [null, Validators.required],
            }),
            name: [null],
            ip: [null],
            url: this.fb.group({
              id: [null, Validators.required],
            }),
          }),
        }),
        network: this.getNetworkForm(),
        id: [null],
        uuid: [null],
      }),
      uuid: [null],
      type: [null],
      created: [null],
      updated: [null],
      id: [null],
      displayName: [null],
    });
  }

  getOrder(): FormGroup {
    return this.fb.group({
      addresses: this.fb.array([this.getAddress(), this.getAddress()]),
      client: this.getClientItem(),
      misc: this.fb.group({
        commentsForm: this.fb.group({
          commentsBlog: [null],
          comments: [null],
        }),
        expeditionForm: this.fb.group({
          expeditionDate: [null, Validators.required],
          hasMaterial: [null],
          hasSetup: [null],
          orderCountThisDay: [null],
        }),
        shipmentForm: this.fb.group({
          shipment: [2],
        }),
        byForm: this.fb.group({
          updatedBy: [null],
          createdBy: [null],
        }),
        playerInfo: this.fb.group({
          displayName: [null],
          deviceMacAddress: [null],
          deviceID: [null],
        }),
      }),
      contact: this.getContact(),
      site: this.fb.group({
        id: [null],
        uuid: [null],
        externalID: [null],
        name: [
          null,
          [Validators.required, Validators.minLength(3)],
   //       [this.isUniquePromise2(this.duplicate)],
        ],
        ianaCode: [null, Validators.required],
        timezoneName: [null],
      }),
      productionLine: this.fb.group({
        productionLine: this.fb.group({
          code: [null, Validators.required],
          name: [null],
        }),
      }),
      subscription: this.fb.group({
        general: this.fb.group({
        cultures: this.fb.group({
          code: [null, Validators.required],
          name: [null],
          common: [null],
          rtl: [null],
        }),
        statutoryName: [null],
        name: [null, Validators.required]
        }),
        base: this.fb.group({
          name: [null],
          prefix: [null],
          productForm: this.fb.group({
            isSold: [null],
            product: this.fb.group({
              id: [null, Validators.required],
              name: [null],
              audio: [null],
              video: [null],
            }),
            service: this.fb.group({
              id: [null, Validators.required],
              name: [null]
            }),
            status: this.fb.group({
              id: [null, Validators.required],
              name: [null],
              audio: [null],
              video: [null],
            }),
            screenRotation: this.fb.group({
              id: [{ value: null, disabled: true }, Validators.required],
              name: [{ value: null, disabled: true }],
            }),
          }),
          serverForm: this.fb.group({
            server: this.fb.group({
              id: [null],
            }),
            name: [null],
            ip: [null],
            url: this.fb.group({
              id: [null, Validators.required],
            }),
            cms: this.fb.group({
              id: [null, Validators.required],
            }),
          }),

        }),
        network: this.getNetworkForm(),
        id: [null],
        uuid: [null],
      }),
      uuid: [null],
      type: [null],
      created: [null],
      updated: [null],
      id: [null],
      displayName: [null],
      concepts: this.fb.group({
        concepts: this.fb.group({
          color: [null],
          name: [null],
          id: [null],
        }),
      })
    });
  }

  getNetworkForm(): FormGroup {
    return this.fb.group({
      status: [null],
      isOrderOpened: [null],
      ipAddress: this.fb.group(
        {
          dns1: [null, [Validators.required, Validators.pattern(IP_PATTERN)]],
          dns2: [null, [Validators.required, Validators.pattern(IP_PATTERN)]],
          gateway: [
            null,
            [Validators.required, Validators.pattern(IP_PATTERN)],
          ],
          mask: [null, [Validators.required, Validators.pattern(IP_PATTERN)]],
          ip: [null, [Validators.required, Validators.pattern(IP_PATTERN)]],
          isDhcp: [null],
          id: [null],
          uuid: [null],
        },
        { validator: ipGatewayValidator(this.ipGatewayValidatorService) }
      ),
      wifi: this.fb.group({
        id: [null],
        ssid: [null],
        uuid: [null],
        security_password: [null],
        security_type: this.fb.group({ code: [null], name: [null] }),
        eap_phase_2_authentication: this.fb.group({
          code: [null],
          name: [null],
        }),
        eap_methodName: this.fb.group({ code: [null], name: [null] }),
        eap_identity: [null],
        eap_ca_certificate: [null],
        eap_password: [null],
        eap_anonymous_identity: [null],
        eap_user_certificate: [null],
        enable: [null],
      }),
      proxy: this.fb.group({
        address: [null],
        addressProxy: [null],
        enable: [null],
        login: [null],
        password: [null],
        port: [
          null,
          [
            Validators.min(1),
            Validators.max(65535),
            Validators.pattern('^[0-9]*$'),
          ],
        ],
      }),
    });
  }

  getAddress(): FormGroup {
    return this.fb.group({
      addressType: [null, Validators.required],
      checkBox: [true],
      city: [null, Validators.required],
      countryForm: this.fb.group({
        name: [null, Validators.required],
      }),
      country: [null],
      created: [null],
      createdBy: [null],
      id: [null],
      line1: [null, Validators.required],
      line2: [null],
      line3: [null],
      name: [null],
      state: [null],
      updated: [null],
      updatedBy: [null],
      uuid: [null],
      zip: [null, Validators.required],
    });
  }

  getAddresses(): FormGroup {
    return this.fb.group({
      addresses: this.fb.array([this.getAddress()]),
    });
  }

  getContacts(): FormGroup {
    return this.fb.group({
      contacts: this.fb.array([this.getContact()]),
    });
  }

  getContact(): FormGroup {
    return this.fb.group({
      comments: [null],
      culture: [null],
      created: [null],
      createdBy: [null],
      department: [null],
      email: [null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      groupRole: [null],
      id: [null],
      mobile: [null, Validators.pattern(PHONE_NUMBER_PATTERN)],
      name: [null, Validators.required],
      phone: [
        null,
        [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)],
      ],
      sex: [null],
      skype: [null],
      surname: [null, Validators.required],
      typeUser: [null],
      uuid: [null],
      updated: [null],
      updatedBy: [null],
    });
  }

  getClientItem(): FormGroup {
    return this.fb.group({
      uuid: [null, Validators.required],
    });
  }

  getFilterOrder(): FormGroup {
    return this.fb.group({
      siteName: [],
      type: this.fb.group({ id: [null], name: [null] }),
      clientName: [],
      countryCode: this.fb.group({ code: [null], name: [null] }),
      serviceID: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
      expeditionDate: [],
      pickupDate: [],
      deliveryDate: [],
      playerName: [],
      expeditionDateStart: [],
      expeditionDateStop: [],
      pickupDateStart: [],
      pickupDateStop: [],
      deliveryDateStart: [],
      deliveryDateStop: [],
      id: [],
      status: this.fb.group({ id: [null], name: [null] }),
    });
  }

  getFilterClient(): FormGroup {
    return this.fb.group({
      name: [],
      office: this.fb.group({ id: [null], name: [null] }),
      salesId: this.fb.group({ id: [null], name: [null] }),
      serviceIds: this.fb.group({ id: [null], name: [null] }),
    });
  }

  getValidationTicket(): FormGroup {
    return this.fb.group({
      assignedTo: this.fb.group({
        id: [null, Validators.required],
        name: [null],
      }),
      description: [null, Validators.required],
      dueDate: [
        null,
        [
          Validators.required,
          Validators.pattern(NOT_INVALID_DATE_STRING_PATTERN),
        ],
      ],
      titleTicket: ['DEPLOY', Validators.required],
      titleTodo: ['VALIDATION', Validators.required],
    });
  }
  getShippingForm(): FormGroup {
    return this.fb.group({
      addresstype: this.fb.group({ id: [null], name: [null] }),
      Name: [null, Validators.required],
      Firstname: [null, Validators.required],
      Company: [null, Validators.required],
      Address: [null, Validators.required],
      Postalcode: [null, Validators.required],
      Email: [null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      Tel: [null, Validators.pattern(PHONE_NUMBER_PATTERN)],
      Description: [null, Validators.required],
      Reference: [null, Validators.required],
      Weight: [null, [Validators.pattern(/^-?[0-9]+(\.[0-9]{1,2})?$/)]],
      Height: [null, [Validators.pattern(/^-?[0-9]+(\.[0-9]{1,2})?$/)]],
      Width: [null, [Validators.pattern(/^-?[0-9]+(\.[0-9]{1,2})?$/)]],
      Length: [null, [Validators.pattern(/^-?[0-9]+(\.[0-9]{1,2})?$/)]],
      CityName: [null, Validators.required],
      ShippingDateTime: [null, Validators.required],
      boxtype: this.fb.group({ id: [null], name: [null] }),
      country: this.fb.group({ code: [null], name: [null] }),
      Product: this.fb.group({
        productCode: [null, Validators.required],
        productName: [null],
        totalPrice: [null]
      }),
      transporter: this.fb.group({ id: [null], name: [null] }),
    });
  }

  getReturnForm(): FormGroup {
    return this.fb.group({
      ReferenceReturn: this.fb.group({name: [null] }),
    });
  }

  getProductionLine(): FormGroup {
    return this.fb.group({
      productionLine: this.fb.group({
        code: [null, Validators.required],
        name: [null],
      }),
    });
  }

  getPickUp(): FormGroup {
    return this.fb.group({
      transporterID: this.fb.group({
        id: [null, Validators.required],
        name: [null],
      }),
      trackingID: [null, Validators.required],
      shipFromTrackingID: [null],
      departureDate: [
        null,
        [
          Validators.required,
          Validators.pattern(NOT_INVALID_DATE_STRING_PATTERN),
        ],
      ],
    });
  }

  getCloseOrder(): FormGroup {
    return this.fb.group({
      departureDate: [
        null,
        [
          Validators.required,
          Validators.pattern(NOT_INVALID_DATE_STRING_PATTERN),
        ],
      ],
    });
  }

  getAssignPlayer(): FormGroup {
    return this.fb.group({
      id: [null, Validators.required],
      name: [null],
    });
  }
  getAssignAdoptionPlayer(): FormGroup {
    return this.fb.group({
      familiesName: this.fb.group({
        id: [null, Validators.required],
        name: [null],
      }),
      bsnProductModel: this.fb.group({
        id: [null],
        name: [null],
      }),
      code: [null],
   //   serialNumber: [null],
      isDefault: [false],
      concepts: this.fb.group({
        color: [null],
        name: [null],
        id: [null],
      }),
    });
  }
  getConceptsPlayer(): FormGroup {
    return this.fb.group({
      concepts: this.fb.group({
        color: [null],
        name: [null],
        id: [null],
      }),
    });
  }
  getSiteAssignPlayer(): FormGroup {
    return this.fb.group({
      id: [null, Validators.required],
      name: [null],
      isDefault: [false],
    });
  }


  getFilterSite(): FormGroup {
    return this.fb.group({
      city: [],
      country: this.fb.group({ code: [null], name: [null] }),
      status: this.fb.group({ id: [null], name: [null] }),
      extId: [],
      line1: [],
      name: [],
      companyName: [],
      quickSearch: [],
      zip: [],
    });
  }

  getFilterPilotPlayers(): FormGroup {
    return this.fb.group({
      clientName: [],
      siteName: [],
      countryCode: [],
      productID: [],
      serviceID: [],
      deliveryDate: [],
      numberOfDays: [],
      salesName: [],
      deviceID: [],
      playerName: [],
      updated: [],
    });
  }

  getSubscription(): FormGroup {
    return this.fb.group({
      isOrderOpened: [null],
      site: this.fb.group({
        displayName: [
          null,
          [
            Validators.required,
            Validators.maxLength(250),
            Validators.minLength(3),
          ],
        ],
        extId: [null],
        timezone: this.fb.group({
          id: [null],
          name: [null],
          ianaCode: [null, Validators.required],
        }),
      }),
      subscription: this.fb.group({
        name: [null, Validators.required],
        statutoryName: [null],
        product: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        status: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        service: this.fb.group({ id: [null], name: [null] }),
        cultures: this.fb.group({
          code: [null, Validators.required],
          name: [null],
          common: [null],
          rtl: [null],
        }),

        isSold: [null],
      }),
      serverForm: this.fb.group({
        server: this.fb.group({
          id: [null],
        }),
        name: [null],
        ip: [null],
        url: this.fb.group({
          id: [null, Validators.required],
        }),
        cms: this.fb.group({
          id: [null],
        }),
      }),
      audioOption: this.fb.group({
        licence: this.fb.group({ id: [null], name: [null] }),
        cd: [null],
      }),
      videoOption: this.fb.group({
        screenRotation: this.fb.group({ id: [null], name: [null] }),
      }),
      concepts: this.fb.group({
        concepts: this.fb.group({
        color: [null],
        name: [null],
        id: [null],
      }),
      })
    });
  }
  getSubscriptionDetail(): FormGroup {
    return this.fb.group({
      isOrderOpened: [null],
      subscription: this.fb.group({
        cultures: this.fb.group({
          code: [null, Validators.required],
          name: [null],
          common: [null],
          rtl: [null],
        }),
        product: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        status: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        service: this.fb.group({ id: [null], name: [null] }),
        name: [null],
        isSold: [null],
        statutoryName: [null],
      }),
      serverForm: this.fb.group({
        server: this.fb.group({
          id: [null, Validators.required],
        }),
        cms: this.fb.group({
          id: [null, Validators.required],
        }),
        name: [null],
        ip: [null],
        url: this.fb.group({
          id: [null, Validators.required],
        }),
      }),
      audioOption: this.fb.group({
        licence: this.fb.group({ id: [null], name: [null] }),
        cd: [null],
      }),
      videoOption: this.fb.group({
        screenRotation: this.fb.group({ id: [null], name: [null] }),
      }),
      concepts: this.fb.group({
        concepts: this.fb.group({
          color: [null],
          name: [null],
          id: [null],
        }),
      })
    });
  }

  getSubscriptionMulti(): FormGroup {
    return this.fb.group({
      isOrderOpened: [null],
      site: this.fb.group({
        displayName: [
          null,
          [
            Validators.required,
            Validators.maxLength(50),
            Validators.minLength(3),
          ],
        ],
        extId: [null],
        timezone: this.fb.group({
          id: [null],
          name: [null],
          ianaCode: [null, Validators.required],
        }),
      }),
      subscription: this.fb.group({
        product: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        status: this.fb.group({
          id: [null, Validators.required],
          name: [null],
        }),
        service: this.fb.group({ id: [null], name: [null] }),
        isSold: [null],
      }),
      serverForm: this.fb.group({
        server: this.fb.group({
          id: [null, Validators.required],
        }),
        name: [null],
        ip: [null],
        url: this.fb.group({
          id: [null, Validators.required],
        }),
      }),
      audioOption: this.fb.group({
        licence: this.fb.group({ id: [null], name: [null] }),
        cd: [null],
      }),
      videoOption: this.fb.group({
        screenRotation: this.fb.group({ id: [null], name: [null] }),
      }),

    });
  }

  getMiscellaneous(): FormGroup {
    return this.fb.group({
      information: this.fb.group({
        created: [null],
        createdBy: [null],
        updated: [null],
        updatedBy: [null],
      }),
      commentsForm: this.fb.group({
        commentsBlog: [null],
        comments: [null],
      }),
    });
  }

  getFilterPlayer(): FormGroup {
    return this.fb.group({
      displayName: [],
      lastConnection: [],
      isDefault: this.fb.group({ id: [null], name: [null] }),
      deviceID: [],
      deviceModel: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
      deviceFirmware: [],
      deviceMacAddress: [],
      showHistory: [],
    });
  }
  getFilterSubscription(): FormGroup {
    return this.fb.group({
      subscriptionName: [],
      status: this.fb.group({ id: [null], name: [null] }),
      clientName: [],
      startBilling: [],
      startBillingRangeStart: [],
      startBillingRangeEnd: [],
      price: [null],
      endBilling: [],
      endBillingRangeStart: [],
      endBillingRangeEnd: [],
      deliveryDate: [],
      deliveryDateRangeStart: [],
      deliveryDateRangeEnd: [],
      contractName: [],
      service: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
    });
  }
  getFilterSubscriptionSimpleList(): FormGroup {
    return this.fb.group({
      subscriptionName: [],
      status: this.fb.group({ id: [null], name: [null] }),
      clientName: [],
      siteName: [],
      service: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
    });
  }
  getFilterSubscriptionSimple(): FormGroup {
    return this.fb.group({
      name: [],
      status: this.fb.group({ id: [null], name: [null] }),
      service: this.fb.group({ id: [null], name: [null] }),
      productID: this.fb.group({ id: [null], name: [null] }),
      cultures: this.fb.group({
        code: [null, Validators.required],
        name: [null],
        common: [null],
        rtl: [null],
      }),
    });
  }
  getFilterProject(): FormGroup {
    return this.fb.group({
      Name: [],
      sfProjectID: [],
      sapProjectID: [],
      created: [],
      updated: [],
    });
  }
  getPlayerConfiguration(): FormGroup {
    return this.fb.group({});
  }

  getFilterPublication(): FormGroup {
    return this.fb.group({
      name: [],
      packageID: [],
      type: this.fb.group({ id: [null], name: [null] }),
      version: [],
      startDate: [],
      endDate: [],
      created: [],
      status: this.fb.group({ id: [null], name: [null] }),
      sent: this.fb.group({ id: [null], name: [null] }),
    });
  }
  getInvoicesManagement(): FormGroup {
    return this.fb.group({
      clearInvoices: [null],
      usePeriodic: [null],
    });
  }

  getLinkContract(): FormGroup {
    return this.fb.group({
      startBilling: [null, Validators.required],
      endBilling: [null],
      companyName: [null, Validators.required],
      companyUuid: [null, Validators.required],
      contractName: [null, Validators.required],
      contractUuid: [null, Validators.required],
      onlyNotLinked: [null, Validators.required],
      subscriptionName: [],
      isBillingLinked: [],
      subscriptionUuid: [],
    });
  }
  getReturnPlayers(): FormGroup {
    return this.fb.group({
      comment: [null],
      playerLost: [null],
    });
  }
  getRemovePlayerLostOrSold(): FormGroup {
    return this.fb.group({
      reason: [null],
    });
  }
  getLinkContractAnomalies(): FormGroup {
    return this.fb.group({
      startBilling: [null, Validators.required],
      endBilling: [null, Validators.required],
      companyName: [null, Validators.required],
      companyUuid: [null, Validators.required],
      contractName: [null, Validators.required],
      contractUuid: [null, Validators.required],
      endlessEndDate: [],
    });
  }
  getDuplicationContract(): FormGroup {
    return this.fb.group({
      name: [null],
      start: [null, Validators.required],
      end: [null],
      companyName: [null, Validators.required],
      companyUuid: [null, Validators.required],
      isRuleDuplicate: [],
      prefix: [],
    });
  }
  closeSubscription(): FormGroup {
    return this.fb.group({
      startBilling: [],
      endBilling: [null, Validators.required],
      comment: [null],
      //  subscriptionUuid:  [null, Validators.required],
    });
  }
  closeSubscriptionWithoutValidator(): FormGroup {
    return this.fb.group({
      startBilling: [],
      endBilling: [],
      comment: [null],
      //  subscriptionUuid:  [null, Validators.required],
    });
  }
  getFilterCompanyInvoices(): FormGroup {
    return this.fb.group({
      number: [],
      purchaseOrder: [],
      isAdjustment: [],
      code: [],
      logisticJournal: [],
      officeID: this.fb.group({ name: [null], id: [null] }),
      countryCode: this.fb.group({ code: [null], name: [null] }),
      logisticsIdentifier: [],
      companyName: [],
      contractName: [],
      split: this.fb.group({ id: [null], name: [null] }),
      coverStart: [],
      coverEnd: [],
      date: [],
      count: [],
      unitPrice: [],
      total: [],
      created: [],
    });
  }
  getFilterContract(): FormGroup {
    return this.fb.group({
      name: [null],
      po: [null],
      startDate: [null],
      endDate: [null],
      price: [null],
    });
  }

  getProjectCreation(): FormGroup {
    return this.fb.group({
      name: [null],
      salesforceProjectId: [null],
    });
  }
  getLanguageTextsContract(): FormGroup {
    return this.fb.group({
      globalForm: this.fb.group({
        loc: [null, Validators.required],
        locDay: [null, Validators.required],
        locDayMon: [null, Validators.required],
      }),
      feesForm: this.fb.group({
        routerManagementLicense: [null, Validators.required],
        audioPlayerRental: [null, Validators.required],
        videoPlayerRental: [null, Validators.required],
        braketRental: [null, Validators.required],
        DIV: [null, Validators.required],
        DIVPercent: [null, Validators.required],
        materialLocation: [null, Validators.required],
        maint: [null, Validators.required],
        musicService: [null, Validators.required],
        softwareService: [null, Validators.required],
        monitorRental: [null, Validators.required],
        projectManagement: [null, Validators.required],
        onlineMaintenance: [null, Validators.required],
        setup: [null, Validators.required],
        prod: [null, Validators.required],
        remoteManagement: [null, Validators.required],
        SIMDataService: [null, Validators.required],
        SSLCertificateRenewal: [null, Validators.required],
        widgetService: [null, Validators.required]
      }),
      replacement: this.fb.group({
        recurrence: [null, Validators.required],
        product: [null, Validators.required],
        productLoc: [null, Validators.required],
        service: [null, Validators.required],
      }),
    });
  }
}
